<template>
    <b-card no-body class="InterCard shadow">
        <div v-bind:style="{backgroundColor : `#001ea0`}"
             class="InterCard-header" v-if="title !== ''">
            <div>{{title}}</div>
            <i class="fi" :class="titleIcon" v-if="titleIcon"></i>
        </div>
        <div class="InterCard-body" v-bind:class="noBody ? '' : 'withPadding'">
            <slot></slot>
        </div>
    </b-card>
</template>

<script>

    import {mapGetters} from 'vuex'
    export default {
        name: "InterCard",
        props: {
            title: {
                type: String,
                default: ''
            },
            titleIcon: {
                type: String,
                default: ''
            },
            noBody: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapGetters([
                'currentUser',
            ]),
        }
    }
</script>

<style lang="scss">


</style>
